import isSecureCookie from 'shared/utils/isSecureCookie'
import {
  AUTH_COOKIE_NAME,
  AUTH_COOKIE_NAME_REDIRECT
} from 'shared/consts/authCookie'
import Cookies, { SetOption } from 'cookies'
import logger from 'shared/services/logger'

const COOKIE_EXPIRATION = 24 * 60 * 60 * 1000
const TOKEN_TYPE = 'Bearer'
const TOKEN_TYPE_REGEX = /^BEARER /gi
export const defaultCookieOptions: SetOption = {
  httpOnly: true,
  maxAge: COOKIE_EXPIRATION,
  overwrite: true,
  path: '/',
  sameSite: 'lax'
}

function prepareToken(token: string) {
  return token.replace(TOKEN_TYPE_REGEX, '').trim()
}

const checkRedirectPaths = url =>
  url.includes('/redirect') || url.includes('/experiments')

export function setAuthCookie(cookies: Cookies, token: string): void {
  const cookieValue = prepareToken(token)

  try {
    cookies.set(AUTH_COOKIE_NAME, cookieValue, {
      ...defaultCookieOptions,
      secure: isSecureCookie
    })
  } catch (e) {
    logger.error(`${AUTH_COOKIE_NAME} - ${e.message}`, e)
  }

  try {
    cookies.set(AUTH_COOKIE_NAME_REDIRECT, cookieValue, {
      ...defaultCookieOptions,
      sameSite: 'none',
      secure: isSecureCookie
    })
  } catch (e) {
    logger.error(`${AUTH_COOKIE_NAME_REDIRECT} - ${e.message}`, e)
  }
}

export function getAuthCookie(cookies: Cookies): string | undefined {
  let token = cookies.get(AUTH_COOKIE_NAME)

  if (!token && checkRedirectPaths(cookies?.request?.url || '')) {
    token = cookies.get(AUTH_COOKIE_NAME_REDIRECT)
  }

  if (!token) {
    return undefined
  }

  return `${TOKEN_TYPE} ${token}`
}

export function getPlainAuthCookie(cookies: Cookies): string | undefined {
  let token = cookies?.get(AUTH_COOKIE_NAME)

  if (!token && checkRedirectPaths(cookies?.request?.url || '')) {
    token = cookies.get(AUTH_COOKIE_NAME_REDIRECT)
  }

  return token
}

export function deleteAuthCookie(cookies: Cookies): void {
  cookies.set(AUTH_COOKIE_NAME, '', { ...defaultCookieOptions, maxAge: -1 })
  cookies.set(AUTH_COOKIE_NAME_REDIRECT, '', {
    ...defaultCookieOptions,
    maxAge: -1
  })
}
